import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const DeleteFileFromS3TaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="deleteFileFromS3TaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="deleteFileFromS3"
      />
      <FormField
        controlId="deleteFileFromS3TaskFormTargetS3Bucket"
        label="targetS3Bucket"
        name="parameters.targetS3Bucket"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target S3 bucket"
        error={errors.parameters?.targetS3Bucket?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormFileKey"
        label="fileKey"
        name="parameters.fileKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter file key"
        error={errors.parameters?.fileKey?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormDeleteBucket"
        label="deleteBucket"
        name="parameters.deleteBucket"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormAwsAccessKeyId"
        label="awsAccessKeyId"
        name="parameters.awsAccessKeyId"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS Access Key ID"
        error={errors.parameters?.awsAccessKeyId?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormAwsSecretAccessKey"
        label="awsSecretAccessKey"
        name="parameters.awsSecretAccessKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter AWS Secret Access Key"
        error={errors.parameters?.awsSecretAccessKey?.message}
      />
      <FormField
        controlId="deleteFileFromS3TaskFormAwsRegion"
        label="awsRegion"
        name="parameters.awsRegion"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS Region"
        error={errors.parameters?.awsRegion?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DeleteFileFromS3TaskForm;
